<template>
<div>
    <v-row class="pa-3">
        <div v-if="type == 'record'">
            Аудиоролик для рассылки
        </div>
        <div v-if="type == 'repeatRecord'">
            Аудиоролик для повтора
        </div>
    </v-row>
    <v-row>
        <v-select
            outlined            
            v-model="source"
            :items="sources"
            item-text="name"
            item-value="type"
            label="Источник аудиоролика"
            persistent-hint
            @change="changeType()"
        ></v-select>
    </v-row>
    <v-row v-if="source == 'text'">
        <v-col cols="12">
            <v-switch
                v-model="gender"
                true-value="1"
                false-value="0"
                :label="gender==0 ? 'Женский голос' : 'Мужской голос'"
                @change="changeType()"
            ></v-switch>
        </v-col>
        <v-col cols="12">
            <v-textarea
                outlined
                v-model="text_for_generation"
                @blur="changeType()"
            ></v-textarea>
        </v-col>
    </v-row>
    <v-row v-if="source == 'saved'">
        <v-select
            outlined
            v-model="selected_audio_id"
            :items="savedAudio"
            item-text="name"
            item-value="id"
            label="Выбор аудиоролика"
            persistent-hint
            @change="changeType()"
        ></v-select>
        <audio v-if="selected_audio_id && savedAudio" controls :src="savedAudio.find(element => element.id == selected_audio_id).path"></audio>
    </v-row>
</div>
</template>

<script>
export default {
    name: "audioElement",
    props: [
        "element", 
        "type"
    ],
    data() {
        return {
            source: null,
            sources: [
                {
                    name: 'Сохраненные',
                    type: 'saved'
                },
                {
                    name: 'Текст',
                    type: 'text'
                },
            ],
            selected_audio_id: null,
            text_for_generation: '',
            gender: 0,
        }
    },
    created() {
        if (this.element.hasOwnProperty(this.type)) {
            if (this.element[this.type].hasOwnProperty("id")) {
                this.source = 'saved';
                this.selected_audio_id = this.element[this.type].id
            }
            if (this.element[this.type].hasOwnProperty("text")) {
                this.source = 'text';
                this.text_for_generation = this.element[this.type].text;
                this.gender = this.element[this.type].gender;
            }            
        } else {
            this.source = this.sources[0].type;
        }
        this.$store.dispatch('GET_RECORDS');
    },
    computed: {
        savedAudio() {
            return this.$store.getters.RECORDS;
        }
    },
    methods: {
        changeType() {
            if (!this.element.hasOwnProperty(this.type)) {
                delete this.element[this.type]
            }
            switch (this.source) {
                case 'saved':
                        this.element[this.type] = {
                            "id": this.selected_audio_id,
                        }
                    break;
                case 'text':
                        this.element[this.type] = {
                            "text": this.text_for_generation,
                            "gender": this.gender,
                        }
                    break;
            
                default:
                    break;
            }
            this.element.ivrs.push();
        },
    }
}
</script>

<style>

</style>